import { forwardRef, type InputHTMLAttributes, useId } from "react";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
  hint?: string;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", error, hint, id, label, ...props }, ref) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;

    return (
      <div className="space-y-2">
        <label className="block text-sm font-medium text-ink" htmlFor={inputId}>
          {label}
        </label>
        <input
          className={[
            "block min-h-11 w-full rounded-md border bg-field px-3.5 py-2.5 text-base text-ink shadow-sm outline-none transition placeholder:text-graphite/40 focus:border-ink focus:ring-2 focus:ring-ink/10",
            error ? "border-red-700" : "border-line",
            className,
          ].join(" ")}
          id={inputId}
          ref={ref}
          {...props}
        />
        {hint ? <p className="text-sm text-graphite/65">{hint}</p> : null}
        {error ? <p className="text-sm font-medium text-red-800">{error}</p> : null}
      </div>
    );
  },
);

Input.displayName = "Input";
